import { Link } from "react-router-dom";
import './person.css' 
import React from 'react';




function Person({person}) {
  console.log(person);
  return (
    <div className="person">
      <Link to={`/person/${person.id}`} key={person.id}>
        <h2>{person.firstName}</h2>
        <img
          src={person.imageUrl}
          alt={person.firstName}
          className="personImage"
        />
        <p>{person.district}</p>
      </Link>
      <a
        href={createWhatsAppLink(
          person.phoneNumber,
          "Merhaba, size nasıl yardımcı olabilirim?"
        )}
        target="_blank"
        rel="noopener noreferrer"
      >
        WhatsApp Mesajı Gönder
      </a>
    </div>
  );
}

export default Person;

function createWhatsAppLink(phoneNumber, message) {
  const encodedMessage = encodeURIComponent(message);
  return `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodedMessage}&type=phone_number&app_absent=0`;
}
